import { render, staticRenderFns } from "./BulletFrame.vue?vue&type=template&id=623b2531&scoped=true"
import script from "./BulletFrame.vue?vue&type=script&lang=js"
export * from "./BulletFrame.vue?vue&type=script&lang=js"
import style0 from "./BulletFrame.vue?vue&type=style&index=0&id=623b2531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a384144eff487845a016474d887108a3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b2531",
  null
  
)

export default component.exports